/* eslint-disable @typescript-eslint/no-explicit-any */
import { Accordion } from "components/ui/accordion";
import { AccordionCreated } from "./accordion-bc/accordion-created";
import { AccordionUpdatedInitialTerms } from "./accordion-bc/accordion-initial";
import { AccordionUpdatedFinalTerms } from "./accordion-bc/accordion-updated";
import { InfoValues } from "./accordion-bc/info-values";

export function ModalDetailsBc({ requestData }: { requestData: any }) {
  const parsedBc =
    typeof requestData.value_history_bc === "string"
      ? JSON.parse(requestData.value_history_bc)
      : requestData.value_history_bc;

  return (
    <div className="space-y-6">
      <div className="pb-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold text-gray-900">
          Detalhes da Base de Cálculo
        </h2>
      </div>
      
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 shadow-sm border border-blue-100">
        <InfoValues requestData={requestData} />
      </div>
      
      <Accordion type="multiple" className="space-y-3">
        {parsedBc?.created?.length > 0 && (
          <AccordionCreated data={parsedBc.created} />
        )}
        {parsedBc?.updatedFinalTerms?.length > 0 && (
          <AccordionUpdatedFinalTerms data={parsedBc.updatedFinalTerms} />
        )}
        {parsedBc?.updatedInitialTerms?.length > 0 && (
          <AccordionUpdatedInitialTerms data={parsedBc.updatedInitialTerms} />
        )}
      </Accordion>
    </div>
  );
}
